export const environment = {
  production: false,
  url: "https://pgs-sandbox.globalaccelerex.com",
  supportUrl: "https://rexpaysupport-dev.globalaccelerex.com",
  ghurl: "https://pgs-sandbox.globalaccelerex.com",
  accessControl: "https://sandbox-v2.globalaccelerex.com",
  appUser: "peter",
  appPwd: "peter",
  encryptKey: "Daga-Valoni-Lawd",
  hostUrl: "sandbox.globalaccelerex.com",
  redirectUrlForMpgs: "https://checkout.myrexpay.com",
  checkOutURL: "https://checkout-dev.globalaccelerex.com",
  // payLinkExtractPoint: ".com",
  payLinkExtractPoint: "/pay",
  payableCode: "3528722",
  merchantCode: "MX7510",
  cpsUrl: "https://pgs-sandbox.globalaccelerex.com",
  posthogKey: "phc_wAQaFPnP3PGkzMneoj2bYhJxgpjtoMWT5FTq9wBXAhz6",
  posthogHost: "https://us.i.posthog.com",
  ghMPGS: "https://pgs.globalaccelerex.com.gh",
  key: `-----BEGIN PGP PUBLIC KEY BLOCK-----
Version: Keybase OpenPGP v1.0.0
Comment: https://keybase.io/crypto

xo0EYKuUZgEEAJ3DqHrrgHXrvdLeJo538tT7Pml+VQjW/fOwHKGHNzQ6Yf+EMpt8
NTSxU2Pu6QjvxGNqEU+5Ejix8Mf57Iyn+Jlhk5nLG4rR/z390wBwyLZzFhgsYKif
5hdKpdg0+CEInp8hwFQyKcH99SDFRhvs6KBB/iHearkCIrwEYKOtn4M5ABEBAAHN
J0FkZWJheW8gQWRlbml5YW4gPGFkZWJlc2xpY2tAZ21haWwuY29tPsKtBBMBCgAX
BQJgq5RmAhsvAwsJBwMVCggCHgECF4AACgkQlaZA9sBWJb95nAP/SiHrax4LSR6b
9aWuzCKwb2URR+DIU9sZMSBhVn2ff8i2JzOEn9IjALJU7pIGPhuf9Dj4iAmOjEts
aM9uggnd5LwUEa3zmRcV+8pqez1e09DJNp437VfFpDU2uzjTX4JSQP2J7L73+lOX
kfcYoxKCsOXuz77iHXUA2BVE7LiBtILOjQRgq5RmAQQAuzdGaE4FR4IaDp1EhQlX
8xFJrfawWWGsEi5IIgwzujWtUiZd379pguAMe0j9Mo2KaMNVHSkMu6GtgEmtbka7
IJ/MEFmb68cx/FH0YPNSRhOjJglbun0/P9ohbIDoNtCrDoscbWKiP3X0UGa5wpul
cJ3nhQXgtSuYzf58DbzdIjsAEQEAAcLAgwQYAQoADwUCYKuUZgUJDwmcAAIbLgCo
CRCVpkD2wFYlv50gBBkBCgAGBQJgq5RmAAoJEGzORcMDtTyGFbMEAJayRvgeVs4K
Y9Eg2/gU3x7ZXiIp2s09pTp2CXJSsrj3wfFfzY/mB9At2BDQd0Infv2MMI5PaPDc
1xTxSCvlEEwqrpMDU0NjjX7bWScmbY3VRf6QLNXw2YbIpd8leSYjxYLdW2IFXM6Z
1JOgYo6J8Z+51SsFEer3Q4Qq8TNj0G0HbOcD/19RojnSDYXXdcXzo7z+xVd47I0B
H9Zeik8DXmw4M1ZxPvhgBOwyBvDFZNIc0FFlfJ7miA6tn4mzXFbInRo9nI4Mahug
5JF2jzHP2tKBrco+EChJ1FuoXN9fZ1jvtIfCpsUnfFj+ws5EeutMk0lp830i3QCP
xkoa5yM+1f3C6jAazo0EYKuUZgEEAMo518czkUlqSUjfNEVJy2NMwWtDKo2Lr8av
TGkrFdhJoQC2Jy55LFZtrQ3oJX+6iNgmb7cHG83nbJ1DVEaJ+kZoSA4f4OfULsKW
ctU6fU+r8PAlis3n7RzQUbHMBdulDOwgPM5G1grBlci19i1QbzjlIOW/aMp1znkf
6tw90zVXABEBAAHCwIMEGAEKAA8FAmCrlGYFCQ8JnAACGy4AqAkQlaZA9sBWJb+d
IAQZAQoABgUCYKuUZgAKCRBP1RVoKGjtdmyFA/9/Nxzl349Nmu3gLV+6B7ybk/av
5m41vIcjwqWX1LuoZVp7CwnlSKHkTiThBDs7wBt7Zx1A0qLEc0ibkjAKG67ZimLX
oaBh0jLkVgvb/ptQl/lI2Vb+yRfWigWlF8BES89Qr2CnjBbUrO+8T6YVw4311B1E
0iGZIvPJa5eRKrZFwyYkBACIucDHDP9Kfca1EUKX2jDucjLP79XXzyZiRvXXvR4E
AYHEW6lIMLDxD7ie1TEJzVfZYUHRgcXaZeAHk0dSoMQnm3pF2un7KZEA6AjmdU5A
/e9yzVX1Lw6l+BkYeovhFswz+r4A65pDIUOGJ1UXUGEaeAzvTYSlrcPcmQYVcL4k
4g==
=6uW/
-----END PGP PUBLIC KEY BLOCK-----`,
  pkey: `-----BEGIN PGP PRIVATE KEY BLOCK-----
Version: Keybase OpenPGP v1.0.0
Comment: https://keybase.io/crypto
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=TxGK
-----END PGP PRIVATE KEY BLOCK-----`,
};
